module.exports = __webpack_public_path__ + "img/tag-1.0a2bf7d3.svg";